import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { HSModal } from './HSModal';
import CustomButton, { ButtonTypes } from '../Common/CustomButton';
import { CloseIcon, SocialIcon } from '../Common/Icons';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { HSText } from '../Common/HSText';
import SendMessage from '../SendMessage/SendMessage';

const SendMessageModal = ({
  useruuid,
  trans,
  record,
  selectedHub,
  onActionClick,
  cancelMessageModal,
  onUserHubActionClick,
}) => {
  const messageRef = useRef(null);
  const messagingApi = useSelector((state) => state.apis.messagingApi);
  const [inputValue, setInputValue] = useState('');
  const [isMessageSendDisabled, setIsMessageSendDisabled] = useState(true);

  const postMessage = () => {
    const errorCallback = (error) => {
      console.error('Error while sending message:', error);
    };
    const successCallback = () => {
      setInputValue('');
      setIsMessageSendDisabled(true);
    };
    try {
      messagingApi.createUserNotification(
        useruuid,
        { message: inputValue, contacts: [{ useruuid: selectedHub?.useruuid }] },
        apiCallback({
          translator: trans,
          failCallback: errorCallback,
          errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  const handleHSModalOk = () => {
    postMessage();
    cancelMessageModal();
    messageRef.current?.removeMessage();
  };

  const handleHSModalCancel = () => {
    setIsMessageSendDisabled(true);
    cancelMessageModal();
    messageRef.current?.removeMessage();
  };

  return (
    <>
      <HSModal
        open={true}
        handleOk={handleHSModalOk}
        title={<HSText className="title-blue">{trans('SENDMESSAGE')}</HSText>}
        handleCancel={handleHSModalCancel}
        content={
          <SendMessage
            record={record}
            ref={messageRef}
            customClassName={'hide-buttons'}
            inputValue={inputValue}
            handleValueChange={setInputValue}
            handleSendDisabled={setIsMessageSendDisabled}
            onActionClick={onActionClick}
            onUserHubActionClick={onUserHubActionClick}
          />
        }
        className="message user-hubs-modal"
        footer={
          <>
            <CustomButton
              label={trans('CANCEL_U')}
              icon={<CloseIcon className="cancel-icon" />}
              onClick={handleHSModalCancel}
            />
            <CustomButton
              type={ButtonTypes.primary}
              label={trans('SENDNOW_U')}
              icon={<SocialIcon />}
              onClick={handleHSModalOk}
              disabled={isMessageSendDisabled}
            />
          </>
        }
      />
    </>
  );
};

SendMessageModal.propTypes = {
  trans: PropTypes.func,
  record: PropTypes.object,
  useruuid: PropTypes.string,
  selectedHub: PropTypes.object,
  onActionClick: PropTypes.func,
  cancelMessageModal: PropTypes.func,
  onUserHubActionClick: PropTypes.func,
};

export default SendMessageModal;
